import { CreditCardMarkerIcon } from './CreditCardMarkerIcon';

/**
 * author: Michael Irigoyen
 * id 21D860AE-A880-4ED2-9E11-617D888BD744
 * name credit-card-marker
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/credit-card-marker.svg
 * tags
 * - Banking 
 * - Navigation 
 */
export const CreditCardLocationIcon = CreditCardMarkerIcon;
export default CreditCardLocationIcon